import { Badge } from '@/components/ui'
import { cn } from '@/lib/utils'
import type { WorkflowScheduleState } from '@/types'
import { CirclePause, CirclePlay } from 'lucide-react'

const STATE_CONFIG: Record<WorkflowScheduleState, { label: string; className: string; Icon: typeof CirclePlay }> = {
  Active: { label: 'Active', className: 'bg-success text-success-foreground border-success-foreground', Icon: CirclePlay },
  Paused: { label: 'Paused', className: 'bg-warning text-warning-foreground border-warning-foreground', Icon: CirclePause },
}

export function ScheduleStateBadge({ state, className }: { state: WorkflowScheduleState; className?: string }) {
  const config = STATE_CONFIG[state] ?? STATE_CONFIG.Active
  const Icon = config.Icon
  return (
    <Badge variant="outline" className={cn(config.className, 'gap-1', className)} data-testid="schedule-state-badge">
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      {config.label}
    </Badge>
  )
}
